import React from 'react';
import {useSelector} from 'react-redux';
import { Card, Typography } from '@material-ui/core';
import NumberFormat from 'react-number-format';
import { BackdropCircular } from 'components';
import { makeStyles } from '@material-ui/core/styles';
import MUIDataTable from 'mui-datatables';


const useStyles = makeStyles(() => ({
  tableRowText: {
    fontSize: '14px',
    letterSpacing: '0.5px',
    lineHeight: '32px',
    wordBreak: 'keep-all',
  },
  tableTitle: {
    fontSize: '15px',
    fontWeight: 500,
    letterSpacing: '0.5px',
    lineHeight: '32px',
    wordBreak: 'keep-all',
  }
}));

const LastOrders = () => {
  const classes = useStyles();
  const {productsLoading} = useSelector((state: IReduxState) => state.products);
  const {isLoading} = useSelector((state: IReduxState) => state.home);
  const { last_orders } = useSelector((state: IReduxState) => state.home.storeStatistic);
  const listOfLastOrders = last_orders || [];
  const lastOrdersColumns = [
    {
      name: 'customer',
      label: 'Account Holder',
      options: {
        setCellHeaderProps: () => ({className: classes.tableTitle, style: { width: '45%'}}),
        customBodyRenderLite: (dataIndex) => {
          const order = listOfLastOrders[dataIndex];

          return (
            <div className={classes.tableRowText}>
              {`${order.customer_first_name} ${order.customer_last_name}`}
            </div>
          );
        }
      }
    },
    {
      name: 'Items',
      lable: 'Items',
      options: {
        setCellHeaderProps: () => ({className: classes.tableTitle, style: { width: '20%'}}),
        customBodyRenderLite: (dataIndex) => {
          const order = listOfLastOrders[dataIndex];

          return (
            <div className={classes.tableRowText}>
              {order.count_of_bought_items}
            </div>
          );
        }
      }
    },
    {
      name: 'Total',
      lable: 'Total',
      options: {
        setCellHeaderProps: () => ({className: classes.tableTitle, style: { width: '25%'}}),
        customBodyRenderLite: (dataIndex) => {
          const order = listOfLastOrders[dataIndex];

          return (
            <NumberFormat
              className={classes.tableRowText}
              fixedDecimalScale
              decimalScale={2}
              value={order.total_of_bought}
              displayType="text"
              thousandSeparator
              prefix="$"
            />
          );
        }
      }
    }

  ];

  return (
    <Card className="m-2 p-5 min-h-520 relative">
      <div className="p-4 text-gray">
        <Typography className="m-4 text-gray" variant="h5">Last Orders</Typography>
        <MUIDataTable
          data={listOfLastOrders}
          columns={lastOrdersColumns}
          options={{
            responsive: 'standard',
            selectableRows: 'none',
            sort: false,
            search: false,
            filter: false,
            download: false,
            print: false,
            pagination: false,
            viewColumns: false,
            elevation: 0,
            rowsPerPage: 5,
          }}
        />
      </div>
      <BackdropCircular loading={isLoading || productsLoading} title="Collecting data..." local />
    </Card>
  );
};

export default LastOrders;
